// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/action/v1/action.proto" (package "c1.api.action.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { AppEntitlementRef } from "../../app/v1/app_refs";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { FormSchemaRef } from "../../form/v1/form";
/**
 * Action represents a workflow action that can be triggered
 *
 * @generated from protobuf message c1.api.action.v1.Action
 */
export interface Action {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: bool enabled = 2;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: string request_policy_id = 3;
     */
    requestPolicyId: string;
    /**
     * @generated from protobuf field: c1.api.form.v1.FormSchemaRef form_schema_ref = 4;
     */
    formSchemaRef?: FormSchemaRef;
    /**
     * @generated from protobuf oneof: visibility
     */
    visibility: {
        oneofKind: "everyone";
        /**
         * @generated from protobuf field: c1.api.action.v1.ActionVisibilityEveryone everyone = 100;
         */
        everyone: ActionVisibilityEveryone;
    } | {
        oneofKind: "appEntitlementRefs";
        /**
         * @generated from protobuf field: c1.api.action.v1.AppEntitlementRefs app_entitlement_refs = 101;
         */
        appEntitlementRefs: AppEntitlementRefs;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf oneof: target_ref
     */
    targetRef: {
        oneofKind: "workflowTemplateRef";
        /**
         * @generated from protobuf field: c1.api.action.v1.WorkflowTemplateRef workflow_template_ref = 200;
         */
        workflowTemplateRef: WorkflowTemplateRef;
    } | {
        oneofKind: "batonResourceActionRef";
        /**
         * @generated from protobuf field: c1.api.action.v1.BatonResourceActionRef baton_resource_action_ref = 201;
         */
        batonResourceActionRef: BatonResourceActionRef;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: string request_instructions = 5;
     */
    requestInstructions: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 6;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 7;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 8;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: string display_name = 9;
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.api.action.v1.ActionVisibilityEveryone
 */
export interface ActionVisibilityEveryone {
}
/**
 * WorkflowTemplateRef is a reference to a workflow template
 *
 * @generated from protobuf message c1.api.action.v1.WorkflowTemplateRef
 */
export interface WorkflowTemplateRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * ActionRef is a reference to an Action
 *
 * @generated from protobuf message c1.api.action.v1.ActionRef
 */
export interface ActionRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * BatonResourceActionRef is a reference to a Baton resource action
 *
 * @generated from protobuf message c1.api.action.v1.BatonResourceActionRef
 */
export interface BatonResourceActionRef {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 3;
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string baton_action_name = 4;
     */
    batonActionName: string;
    /**
     * @generated from protobuf field: string baton_action_display_name = 5;
     */
    batonActionDisplayName: string;
}
/**
 * @generated from protobuf message c1.api.action.v1.AppEntitlementRefs
 */
export interface AppEntitlementRefs {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef refs = 1;
     */
    refs: AppEntitlementRef[];
}
/**
 * Request/Response messages for ActionService
 *
 * @generated from protobuf message c1.api.action.v1.ActionServiceCreateRequest
 */
export interface ActionServiceCreateRequest {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: string request_policy_id = 2;
     */
    requestPolicyId: string;
    /**
     * @generated from protobuf field: c1.api.form.v1.FormSchemaRef form_schema_ref = 3;
     */
    formSchemaRef?: FormSchemaRef;
    /**
     * @generated from protobuf oneof: visibility
     */
    visibility: {
        oneofKind: "everyone";
        /**
         * @generated from protobuf field: c1.api.action.v1.ActionVisibilityEveryone everyone = 100;
         */
        everyone: ActionVisibilityEveryone;
    } | {
        oneofKind: "appEntitlementRefs";
        /**
         * @generated from protobuf field: c1.api.action.v1.AppEntitlementRefs app_entitlement_refs = 101;
         */
        appEntitlementRefs: AppEntitlementRefs;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf oneof: target_ref
     */
    targetRef: {
        oneofKind: "workflowTemplateRef";
        /**
         * @generated from protobuf field: c1.api.action.v1.WorkflowTemplateRef workflow_template_ref = 200;
         */
        workflowTemplateRef: WorkflowTemplateRef;
    } | {
        oneofKind: "batonResourceActionRef";
        /**
         * @generated from protobuf field: c1.api.action.v1.BatonResourceActionRef baton_resource_action_ref = 201;
         */
        batonResourceActionRef: BatonResourceActionRef;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: string request_instructions = 4;
     */
    requestInstructions: string;
    /**
     * @generated from protobuf field: string display_name = 5;
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.api.action.v1.ActionServiceCreateResponse
 */
export interface ActionServiceCreateResponse {
    /**
     * @generated from protobuf field: c1.api.action.v1.Action action = 1;
     */
    action?: Action;
}
/**
 * @generated from protobuf message c1.api.action.v1.ActionServiceGetRequest
 */
export interface ActionServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.action.v1.ActionServiceGetResponse
 */
export interface ActionServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.action.v1.Action action = 1;
     */
    action?: Action;
}
/**
 * @generated from protobuf message c1.api.action.v1.ActionServiceListRequest
 */
export interface ActionServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.action.v1.ActionRef refs = 3;
     */
    refs: ActionRef[];
}
/**
 * @generated from protobuf message c1.api.action.v1.ActionServiceListResponse
 */
export interface ActionServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.action.v1.Action actions = 1;
     */
    actions: Action[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.action.v1.ActionServiceUpdateRequest
 */
export interface ActionServiceUpdateRequest {
    /**
     * @generated from protobuf field: c1.api.action.v1.Action action = 1;
     */
    action?: Action;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.action.v1.ActionServiceUpdateResponse
 */
export interface ActionServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.action.v1.Action action = 1;
     */
    action?: Action;
}
/**
 * @generated from protobuf message c1.api.action.v1.ActionServiceDeleteRequest
 */
export interface ActionServiceDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.action.v1.ActionServiceDeleteResponse
 */
export interface ActionServiceDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.action.v1.ActionServiceSearchRequest
 */
export interface ActionServiceSearchRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.action.v1.ActionRef refs = 4;
     */
    refs: ActionRef[];
    /**
     * @generated from protobuf field: repeated string app_ids = 5;
     */
    appIds: string[];
    /**
     * @generated from protobuf field: c1.api.action.v1.ActionTargetRefTypeFilter target_ref_type_filter = 6;
     */
    targetRefTypeFilter?: ActionTargetRefTypeFilter;
    /**
     * Filter actions by enabled status. If not set, returns all actions.
     *
     * @generated from protobuf field: optional bool enabled = 7;
     */
    enabled?: boolean;
}
/**
 * Filter actions by target reference type without requiring specific IDs
 *
 * @generated from protobuf message c1.api.action.v1.ActionTargetRefTypeFilter
 */
export interface ActionTargetRefTypeFilter {
    /**
     * @generated from protobuf oneof: target_ref_type
     */
    targetRefType: {
        oneofKind: "workflowTemplate";
        /**
         * @generated from protobuf field: c1.api.action.v1.WorkflowTemplateRefFilter workflow_template = 1;
         */
        workflowTemplate: WorkflowTemplateRefFilter;
    } | {
        oneofKind: "batonResourceAction";
        /**
         * @generated from protobuf field: c1.api.action.v1.BatonResourceActionRefFilter baton_resource_action = 2;
         */
        batonResourceAction: BatonResourceActionRefFilter;
    } | {
        oneofKind: undefined;
    };
}
/**
 * Filter for actions targeting workflow templates
 *
 * @generated from protobuf message c1.api.action.v1.WorkflowTemplateRefFilter
 */
export interface WorkflowTemplateRefFilter {
}
/**
 * Filter for actions targeting baton resource actions
 *
 * @generated from protobuf message c1.api.action.v1.BatonResourceActionRefFilter
 */
export interface BatonResourceActionRefFilter {
}
/**
 * @generated from protobuf message c1.api.action.v1.ActionServiceSearchResponse
 */
export interface ActionServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.action.v1.Action list = 1;
     */
    list: Action[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class Action$Type extends MessageType<Action> {
    constructor() {
        super("c1.api.action.v1.Action", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "request_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "form_schema_ref", kind: "message", T: () => FormSchemaRef },
            { no: 100, name: "everyone", kind: "message", oneof: "visibility", T: () => ActionVisibilityEveryone },
            { no: 101, name: "app_entitlement_refs", kind: "message", oneof: "visibility", T: () => AppEntitlementRefs },
            { no: 200, name: "workflow_template_ref", kind: "message", oneof: "targetRef", T: () => WorkflowTemplateRef },
            { no: 201, name: "baton_resource_action_ref", kind: "message", oneof: "targetRef", T: () => BatonResourceActionRef },
            { no: 5, name: "request_instructions", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 9, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.Action
 */
export const Action = new Action$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionVisibilityEveryone$Type extends MessageType<ActionVisibilityEveryone> {
    constructor() {
        super("c1.api.action.v1.ActionVisibilityEveryone", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionVisibilityEveryone
 */
export const ActionVisibilityEveryone = new ActionVisibilityEveryone$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkflowTemplateRef$Type extends MessageType<WorkflowTemplateRef> {
    constructor() {
        super("c1.api.action.v1.WorkflowTemplateRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.WorkflowTemplateRef
 */
export const WorkflowTemplateRef = new WorkflowTemplateRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionRef$Type extends MessageType<ActionRef> {
    constructor() {
        super("c1.api.action.v1.ActionRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionRef
 */
export const ActionRef = new ActionRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BatonResourceActionRef$Type extends MessageType<BatonResourceActionRef> {
    constructor() {
        super("c1.api.action.v1.BatonResourceActionRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "baton_action_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "baton_action_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.BatonResourceActionRef
 */
export const BatonResourceActionRef = new BatonResourceActionRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementRefs$Type extends MessageType<AppEntitlementRefs> {
    constructor() {
        super("c1.api.action.v1.AppEntitlementRefs", [
            { no: 1, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.AppEntitlementRefs
 */
export const AppEntitlementRefs = new AppEntitlementRefs$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionServiceCreateRequest$Type extends MessageType<ActionServiceCreateRequest> {
    constructor() {
        super("c1.api.action.v1.ActionServiceCreateRequest", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "request_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "form_schema_ref", kind: "message", T: () => FormSchemaRef },
            { no: 100, name: "everyone", kind: "message", oneof: "visibility", T: () => ActionVisibilityEveryone },
            { no: 101, name: "app_entitlement_refs", kind: "message", oneof: "visibility", T: () => AppEntitlementRefs },
            { no: 200, name: "workflow_template_ref", kind: "message", oneof: "targetRef", T: () => WorkflowTemplateRef },
            { no: 201, name: "baton_resource_action_ref", kind: "message", oneof: "targetRef", T: () => BatonResourceActionRef },
            { no: 4, name: "request_instructions", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionServiceCreateRequest
 */
export const ActionServiceCreateRequest = new ActionServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionServiceCreateResponse$Type extends MessageType<ActionServiceCreateResponse> {
    constructor() {
        super("c1.api.action.v1.ActionServiceCreateResponse", [
            { no: 1, name: "action", kind: "message", T: () => Action }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionServiceCreateResponse
 */
export const ActionServiceCreateResponse = new ActionServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionServiceGetRequest$Type extends MessageType<ActionServiceGetRequest> {
    constructor() {
        super("c1.api.action.v1.ActionServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionServiceGetRequest
 */
export const ActionServiceGetRequest = new ActionServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionServiceGetResponse$Type extends MessageType<ActionServiceGetResponse> {
    constructor() {
        super("c1.api.action.v1.ActionServiceGetResponse", [
            { no: 1, name: "action", kind: "message", T: () => Action }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionServiceGetResponse
 */
export const ActionServiceGetResponse = new ActionServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionServiceListRequest$Type extends MessageType<ActionServiceListRequest> {
    constructor() {
        super("c1.api.action.v1.ActionServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ActionRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionServiceListRequest
 */
export const ActionServiceListRequest = new ActionServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionServiceListResponse$Type extends MessageType<ActionServiceListResponse> {
    constructor() {
        super("c1.api.action.v1.ActionServiceListResponse", [
            { no: 1, name: "actions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Action },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionServiceListResponse
 */
export const ActionServiceListResponse = new ActionServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionServiceUpdateRequest$Type extends MessageType<ActionServiceUpdateRequest> {
    constructor() {
        super("c1.api.action.v1.ActionServiceUpdateRequest", [
            { no: 1, name: "action", kind: "message", T: () => Action, options: { "validate.rules": { message: { required: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionServiceUpdateRequest
 */
export const ActionServiceUpdateRequest = new ActionServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionServiceUpdateResponse$Type extends MessageType<ActionServiceUpdateResponse> {
    constructor() {
        super("c1.api.action.v1.ActionServiceUpdateResponse", [
            { no: 1, name: "action", kind: "message", T: () => Action }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionServiceUpdateResponse
 */
export const ActionServiceUpdateResponse = new ActionServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionServiceDeleteRequest$Type extends MessageType<ActionServiceDeleteRequest> {
    constructor() {
        super("c1.api.action.v1.ActionServiceDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionServiceDeleteRequest
 */
export const ActionServiceDeleteRequest = new ActionServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionServiceDeleteResponse$Type extends MessageType<ActionServiceDeleteResponse> {
    constructor() {
        super("c1.api.action.v1.ActionServiceDeleteResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionServiceDeleteResponse
 */
export const ActionServiceDeleteResponse = new ActionServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionServiceSearchRequest$Type extends MessageType<ActionServiceSearchRequest> {
    constructor() {
        super("c1.api.action.v1.ActionServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ActionRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 6, name: "target_ref_type_filter", kind: "message", T: () => ActionTargetRefTypeFilter },
            { no: 7, name: "enabled", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionServiceSearchRequest
 */
export const ActionServiceSearchRequest = new ActionServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionTargetRefTypeFilter$Type extends MessageType<ActionTargetRefTypeFilter> {
    constructor() {
        super("c1.api.action.v1.ActionTargetRefTypeFilter", [
            { no: 1, name: "workflow_template", kind: "message", oneof: "targetRefType", T: () => WorkflowTemplateRefFilter },
            { no: 2, name: "baton_resource_action", kind: "message", oneof: "targetRefType", T: () => BatonResourceActionRefFilter }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionTargetRefTypeFilter
 */
export const ActionTargetRefTypeFilter = new ActionTargetRefTypeFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkflowTemplateRefFilter$Type extends MessageType<WorkflowTemplateRefFilter> {
    constructor() {
        super("c1.api.action.v1.WorkflowTemplateRefFilter", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.WorkflowTemplateRefFilter
 */
export const WorkflowTemplateRefFilter = new WorkflowTemplateRefFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BatonResourceActionRefFilter$Type extends MessageType<BatonResourceActionRefFilter> {
    constructor() {
        super("c1.api.action.v1.BatonResourceActionRefFilter", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.BatonResourceActionRefFilter
 */
export const BatonResourceActionRefFilter = new BatonResourceActionRefFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionServiceSearchResponse$Type extends MessageType<ActionServiceSearchResponse> {
    constructor() {
        super("c1.api.action.v1.ActionServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Action },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionServiceSearchResponse
 */
export const ActionServiceSearchResponse = new ActionServiceSearchResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.action.v1.ActionService
 */
export const ActionService = new ServiceType("c1.api.action.v1.ActionService", [
    { name: "Create", options: { "authz.method": { role: "EDITOR" } }, I: ActionServiceCreateRequest, O: ActionServiceCreateResponse },
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: ActionServiceGetRequest, O: ActionServiceGetResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: ActionServiceListRequest, O: ActionServiceListResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" } }, I: ActionServiceUpdateRequest, O: ActionServiceUpdateResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" } }, I: ActionServiceDeleteRequest, O: ActionServiceDeleteResponse },
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: ActionServiceSearchRequest, O: ActionServiceSearchResponse }
]);
